import React from 'react'

import { formField } from 'decorators'

import MultiSelect from './MultiSelect'

export default formField(props => <MultiSelect {...props} />)
